export const ALL_FORMS_ITEMS_PER_PAGE = 4;
export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const FIRST_LAST_NAME_REGEX = /^[A-Za-z]+$/;
export const FULL_NAME_REGEX = /^((?:[A-Za-z]+ ?){1,3})$/;
// export const FORM_EMBED_URL = "https://opp.demo.technosoftwares.com/product";
export const FORM_EMBED_URL = process.env.REACT_APP_WEBSITE_URL + "/product";
export const TOAST_DEFAULT_TIMING = 2500;
export const OPP_PORTAL_CURRENCY = "£";
